 import { NgModule } from '@angular/core';
 import { CommonModule } from '@angular/common';

 import { DatepickerNlDirective } from './datepicker-nl.directive';
 import { HelpTextTriggerComponent } from './help-text-trigger/help-text-trigger.component';
 import { HelpTextContentComponent } from './help-text-content/help-text-content.component';
 import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
 import { ModelPageComponent } from './model-page/model-page.component';

 @NgModule({
     imports: [
         CommonModule,
     ],
     exports: [
         DatepickerNlDirective,
         HelpTextTriggerComponent,
         HelpTextContentComponent,
         NavigationBarComponent,
         ModelPageComponent
     ],
     declarations: [
         DatepickerNlDirective,
         HelpTextTriggerComponent,
         HelpTextContentComponent,
         NavigationBarComponent,
         ModelPageComponent
     ]
 })
 export class UiModule { }
